class AppError {
  public message: string;

  public statusCode: number;

  constructor(message: string, statusCode = 400) {
    this.message = message;
    this.statusCode = statusCode;
    console.error(message);
  }
}

export default AppError;
